import React from 'react'
import { QueryClient, QueryClientProvider } from 'react-query'
import { BrowserRouter } from 'react-router-dom'
import { Provider } from 'react-redux'
import { CssBaseline } from '@mui/material'
import { NotificationProvider } from '@/providers/NotificationProvider'
import { I18nProvider } from '@/contexts/I18nContext'
import { SsoMenuProvider } from '@/contexts/SsoMenuContext'
import { ThemeAccentProvider } from '@/contexts/ThemeAccentContext'
import ThemeFaviconUpdater from '@/theme/ThemeFaviconUpdater'
import { store } from '@/redux/store'
import AppRouter from '@/AppRouter'
import { ImagePreviewHost } from '@/components/common/imagePreview'
import EntityCodeModalProvider from '@/components/admin/_shared/entityCode/EntityCodeModalProvider'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: (count, error: unknown) => {
        const errorObj = error as { status?: number }
        if (errorObj?.status === 401 || errorObj?.status === 403) return false
        return count < 3
      },
      retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
    },
  },
})

function App() {
  return (
    <NotificationProvider>
      <QueryClientProvider client={queryClient}>
        <ThemeAccentProvider>
          <ThemeFaviconUpdater />
          <CssBaseline />
          <Provider store={store}>
            <BrowserRouter future={{ v7_relativeSplatPath: true }}>
              <SsoMenuProvider>
                <I18nProvider>
                  <EntityCodeModalProvider>
                    <AppRouter />
                  </EntityCodeModalProvider>
                  <ImagePreviewHost />
                </I18nProvider>
              </SsoMenuProvider>
            </BrowserRouter>
          </Provider>
        </ThemeAccentProvider>
      </QueryClientProvider>
    </NotificationProvider>
  )
}

export default App
